// extracted by mini-css-extract-plugin
export var active = "_a2-a";
export var activeIndicator = "_a2-8";
export var animate = "_a2-9";
export var disabled = "_a2-b";
export var fullWidth = "_a2-2";
export var lg = "_a2-7";
export var md = "_a2-6";
export var redoButtonTabGroup = "_a2-0";
export var sm = "_a2-5";
export var tabButton = "_a2-3";
export var tabButtonsContainer = "_a2-1";
export var xs = "_a2-4";